export const CREATE_EDIT_POLL = 'CreateInvitationWidget/*/CreateEditPoll';
export const CREATE_EDIT_WTB = 'CreateInvitationWidget/*/CreateEditWTB';
